// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"440a7d4c","405":"0ef09f95","591":"132db23c","787":"56e64738"}[chunkId] + ".chunk.js";
};